/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { ArrowBack } from "@mui/icons-material";
import { LoadingButton, LoadingButtonProps } from "@mui/lab";
import {
  Box,
  Grid,
  Typography,
  Button,
  Select,
  SelectProps,
} from "@mui/material";
import { PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";

export type DefaultPageHeaderProps = {
  title: string;
  subTitle?: React.ReactNode | string;
  primaryButtonProps?: DefaultPageHeaderButtonProps;
  outlinedButtonProps?: DefaultPageHeaderButtonProps;
  secondaryButtonProps?: DefaultPageHeaderButtonProps;
  thirdButtonProps?: DefaultPageHeaderButtonProps;
  secondarySelectProps?: DefaultPageHeaderSelectProps;
  backButtonLink?: string | any;
  backButtonTitle?: string;
  dropdownSelector?: React.ReactNode;
  showWarningColor?: boolean;
  showTotalEmployees?: boolean;
  total?: number;
  badgeText?: string;
  rightSideComponent?: React.ReactElement;
};

type DefaultPageHeaderButtonProps = PropsWithChildren<
  Omit<LoadingButtonProps, "size" | "variant">
> & {
  requiredPermissions?: string[];
};
type DefaultPageHeaderSelectProps = PropsWithChildren<SelectProps>;

export const DefaultPageHeader = (
  props: DefaultPageHeaderProps
): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: "#F9FAFB",
        borderRadius: "16px",
        p: 3,
        mb: 3,
        border: "1px solid #E5E7EB",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      <Box>
        <Typography variant="h5" sx={{ fontWeight: 600, color: "#1F2937", mb: props.subTitle ? 0.5 : 0 }}>
          {props.title}
        </Typography>
        {props.subTitle && (
          <Typography variant="body2" sx={{ color: "#6B7280", maxWidth: 800 }}>
            {props.subTitle}
          </Typography>
        )}
      </Box>

      <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
        {props.primaryButtonProps && (
          <LoadingButton
            style={{ textTransform: "none" }}
            size="large"
            variant="contained"
            {...props.primaryButtonProps}
          >
            {props.primaryButtonProps.children}
          </LoadingButton>
        )}

        {props.secondaryButtonProps && (
          <LoadingButton
            style={{ textTransform: "none" }}
            size="large"
            variant="contained"
            {...props.secondaryButtonProps}
          >
            {props.secondaryButtonProps.children}
          </LoadingButton>
        )}

        {props.thirdButtonProps && (
          <LoadingButton
            style={{ textTransform: "none" }}
            size="large"
            variant="contained"
            {...props.thirdButtonProps}
          >
            {props.thirdButtonProps.children}
          </LoadingButton>
        )}

        {props.rightSideComponent && (
          <Box>{props.rightSideComponent}</Box>
        )}
      </Box>
    </Box>
  );
};
